// 导出页面为PDF格式
import html2Canvas from './html2canvas';
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function (target) {
      return html2Canvas(target, {
        // allowTaint: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 4,
        scale: 4,
        // tainttest: true
      });
    };
  },
};
